











































































































































































import {Vue, Component} from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import Tooltip from '@/components/Tooltip';

@Component({
  name: 'FilterApartment',
  components: {
    Tooltip,
  },
  props: {
    filters: {
      type: Object,
      default: {},
    },
    design: {
      type: Array,
      default: () => [],
    },
    price: {
      type: Object,
      default: () => {},
    },
    selectedFilters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeSetting: '',
      debounced: debounce(this.sendFiltersData, 500),
      activeDesign: [...this.design],
      rangeFloorData: [...this.selectedFilters.floor],
      rangePriceData: [...this.selectedFilters.price],
      showButton: false,
      showPopup: false,
    };
  },
  computed: {
    rangePrice: {
      get() {
        return !this.rangePriceData.length
          ? [this.filters.price.min, this.filters.price.max]
          : this.rangePriceData;
      },
      set(val) {
        if (!val) {
          return;
        }
        this.$set(this, 'rangePriceData', val);
      },
    },
    rangeFloor: {
      get() {
        return !this.rangeFloorData.length
          ? [this.filters.floor.min, this.filters.floor.max]
          : this.rangeFloorData;
      },
      set(val) {
        if (!val) {
          return;
        }
        this.$set(this, 'rangeFloorData', val);
      },
    },
  },

  methods: {
    sendFiltersData() {
      const data = {
        design: this.activeDesign.length > 0 && this.activeDesign,
        max_price: this.rangePrice[1],
        min_price: this.rangePrice[0],
        max_floor: this.rangeFloor[1],
        min_floor: this.rangeFloor[0],
      };
      this.$emit('sendApartmentFilters', data);
    },

    allDesignIds() {
      let allIds: number[];
      allIds = [];
      for (const design of this.filters.design.items) {
        allIds.push(design.id);
      }
      return allIds;
    },

    openSettings(type) {
      this.showPopup = !this.showPopup;
      this.activeSetting = type;
    },
  },
})
export default class FilterApartment extends Vue {
}
